import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const I: React.FC = () => {
    const { t } = useLang('d3u');
    const imgs: [string, string] = [
        'https://websiteoss.ecoflow.com/upload/image/1761532698376/9.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1760925151818/9_M.jpg',
    ];

    return (
        <section className={`${css.section} D3U-I GtmModuleData-section`} id="D3U-I" data-section-id={'D3U-I'} data-section-id2={t('I_title')}>
            <div className="info">
                <div className="label">{t('I_label')}</div>
                <div className="title">{t('I_title')}</div>
                <div className="desc">{t('I_desc')}</div>
            </div>
            <div className="img">
                <EcoImg pc={imgs[0]} pad={imgs[0]} h5={imgs[1]} />
            </div>
            <div className="tip">{t('I_tip')}</div>
        </section>
    );
};

export default I;
